module.exports = __webpack_public_path__ + "613c20228a8dedefb420346a5265bc4d.svg";